import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,[_c(VCol,{attrs:{"cols":"12 px-4"}},[_c('span',{staticClass:"text-caption"},[_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":`/${_vm.$i18n.locale}/Terms`}},[_vm._v(_vm._s(_vm.$t('nav.top.menu.terms')))]),_c('br'),_vm._v(" © "+_vm._s(_vm.year)+" kontomourtos.gr ALL RIGHTS RESERVED ")],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }